<div class="temporality-container">
  <mat-icon>access_time</mat-icon>
  <div class="temporality-items-wrapper">
    <div
      class="temporality-items temporality-past"
      [style.width.%]="eventsAnalyticsButtonWidth('temp', '1', itemId)"
      matTooltip="Temporality - Past"
    ></div>
    <div
      class="temporality-items temporality-present"
      [style.width.%]="eventsAnalyticsButtonWidth('temp', '2', itemId)"
      matTooltip="Temporality - Present"
    ></div>
    <div
      class="temporality-items temporality-future"
      [style.width.%]="eventsAnalyticsButtonWidth('temp', '3', itemId)"
      matTooltip="Temporality - Future"
    ></div>
    <div
      class="temporality-items temporality-na"
      [style.width.%]="eventsAnalyticsButtonWidth('temp', '4', itemId)"
      matTooltip="Temporality - N/A"
    ></div>
  </div>
</div>
